import { has } from 'lodash';

import { additionalsFlatSimple } from '../../../enums/additionals-flat-simple';

import template from './additional-simple-form.jade';

export default angular
  .module('cian.addForm.additionalSimpleForm', [])
  .directive('cianAfAboutObjectAdditionalSimpleForm', () => ({
    scope: {},
    bindToController: {
      ad: '=',
    },
    controller(
      $scope,
      categoryService,
      deviceService,
    ) {
      'ngInject';
      this.isMobile = deviceService.isMobile;

      this.isEditing = !this.ad.id && !this.ad.isByHomeowner;

      // Часть полей храним локально, т.к. их требуется сохранять в комбинированном виде
      this.localState = {
        hasYardView: undefined,
        hasStreetView: undefined,
      };

      const {dealType} = categoryService.getInfoByCategory(this.ad.category);
      /** @type Array<AdditionalsFlatGroup> */
      this.groups = additionalsFlatSimple[dealType];
      this.groups.forEach(group => {
        group.items.forEach(item => {
          item.modelRoot = has(this.localState, item.model) ? 'localState' : 'ad';
        });
      });

      /* Обработка комбинированных полей */

      const getWindowsType = () => {
        if (this.localState.hasYardView && this.localState.hasStreetView) {
          return 'yardAndStreet';
        }
        if (this.localState.hasStreetView) return 'street';
        if (this.localState.hasYardView) return 'yard';
        return undefined;
      };

      /**
       * Сохранение изменений в ad
       * @param {AdditionalsFlatItem} item
       */
      this.onChange = (item) => {
        if (item.modelRoot === 'localState') {
          this.ad.windowsViewType = getWindowsType();
        }
      };

      // Синхронизация ad -> локальный стэйт
      $scope.$watch(
        () => this.ad.windowsViewType,
        newWindowsType => {
          this.localState.hasYardView = /yard/i.test(newWindowsType);
          this.localState.hasStreetView = /street/i.test(newWindowsType);
        },
      );
    },
    controllerAs: 'additionalSimpleFormCtrl',
    template,
  }))
  .name;
